import { useRef, useEffect, useCallback } from 'react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

function probeImageSize(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        width: img.naturalWidth || 1600,
        height: img.naturalHeight || 1200,
      });
    img.onerror = () => resolve({ width: 1600, height: 1200 });
    img.src = src;
  });
}

/**
 * 이미지 전용 PhotoSwipe 라이트박스 (프로그램적으로 loadAndOpen)
 */
export function useClaimPhotoSwipe() {
  const lightboxRef = useRef(null);

  useEffect(() => {
    const lightbox = new PhotoSwipeLightbox({
      pswpModule: () => import('photoswipe'),
      bgOpacity: 0.94,
      loop: false,
    });
    lightbox.init();
    lightboxRef.current = lightbox;
    return () => {
      try {
        lightbox.destroy();
      } catch (_) {
        /* ignore */
      }
      lightboxRef.current = null;
    };
  }, []);

  const openGallery = useCallback(async (slides, index) => {
    const lb = lightboxRef.current;
    if (!lb || !slides?.length || index < 0 || window.pswp)
      return;
    const rich = await Promise.all(
      slides.map(async (s) => {
        if (s.width > 0 && s.height > 0) return s;
        const d = await probeImageSize(s.src);
        return { ...s, width: d.width, height: d.height };
      })
    );
    lb.loadAndOpen(index, rich);
  }, []);

  return { openGallery };
}
